import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { loadQuestions } from '../../actions/questions';
import { getQuestionsIds } from '../../selectors/questions';
import { getQuestionsLoading } from '../../selectors/questions/getQuestionsLoading';
import { Spinner } from '../../components/Spinner';
import { Transition } from '../../components/Transition';
import { ReviewsList } from '../../components/ReviewsList';
import { QuestionItemContainer } from '../QuestionItem/QuestionItemContainer';
import { EmptyListQuestionsContainer } from '../EmptyListQuestionsContainer';
import { EmptyListContainer } from '../EmptyListContainer';
import { getNewbuildingInfo } from '../../selectors/newbuildingInfo';

export function QuestionsListContainer(): React.JSX.Element {
  const dispatch = useDispatch();
  const ids = useSelector(getQuestionsIds);
  const { questionsCount } = useSelector(getNewbuildingInfo);
  const isLoading = useSelector(getQuestionsLoading);

  React.useEffect(() => {
    if (ids.length === 0) {
      dispatch(loadQuestions());
    }
  }, []);

  if (isLoading) {
    return <Spinner />;
  }

  if (questionsCount === 0) {
    return (
      <Transition>
        <EmptyListQuestionsContainer />
      </Transition>
    );
  }

  if (ids.length === 0) {
    return <EmptyListContainer />;
  }

  return (
    <Transition>
      <ReviewsList>
        {ids.map(questionId => (
          <QuestionItemContainer key={questionId} id={questionId} />
        ))}
      </ReviewsList>
    </Transition>
  );
}
